import { Card } from 'antd';
import type { CardProps } from 'antd';

interface Props extends Omit<CardProps, 'bordered'> {
  bordered?: boolean;
}

export default function EnhancedCard({ bordered = false, ...rest }: Props) {
  // Antd v6 deprecated `bordered` in favour of `variant`.
  return <Card variant={bordered ? 'outlined' : 'borderless'} {...rest} />;
}
